import React from 'react';
import {
    FaAmazon,
    FaRegThumbsUp,
    FaUsers,
    FaShareAltSquare,
    FaRegFileCode,
    FaCarAlt,
    FaShareAlt,
    FaRegCheckCircle,
    FaSearchPlus,
 } from 'react-icons/fa';
import CardAdvantageBox from '../SiteAdvantages';
import { Title } from './style';

const AdvantageBox = () => (
	<div style={{ backgroundColor: '#2E2D37', padding: '0 0 30px 0' }}>
		<Title>Conheça mais vantagens <br /> dos sites Webmotors</Title>
		<div className="row" style={{ marginBottom: '1px', padding: '0 0' }}>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardAdvantageBox
					icon={(<FaRegThumbsUp />)}
					altIcon=""
					titleIcon="Logo"
					title="Experiência"
					text="Uma agência digital com mais de 20 anos de experiência."
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardAdvantageBox
					icon={(<FaUsers />)}
					altIcon=""
					titleIcon="Logo"
					title="Especialista"
					text="Somos especialistas no segmento automotivo."
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4 mt-4 mt-xl-0">
				<CardAdvantageBox
					icon={(<FaShareAltSquare />)}
					altIcon=""
					titleIcon="Logo"
					title="Integração CRM"
					text="Envio dos leads de seu site por e-mail e pelo CRM sem custo adicional"
				/>
			</div>
		</div>
		<div className="row" style={{ marginBottom: '1px', padding: '0 0' }}>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardAdvantageBox
					icon={(<FaRegFileCode />)}
					altIcon=""
					titleIcon="Logo"
					title="Construtor de sites"
					text="Um construtor de sites para você atualizar o seu site quando quiser."
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardAdvantageBox
					icon={(<FaCarAlt />)}
					altIcon=""
					titleIcon="Logo"
					title="Integração estoque"
					text="Exibição do estoque cadastrado no Portal Webmotors com apenas um clique"
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4 mt-4 mt-xl-0">
				<CardAdvantageBox
					icon={(<FaShareAlt />)}
					altIcon=""
					titleIcon="Logo"
					title="Integração terceiros"
					text="Integração com provedores de e-mail, chats, portal de notícias e relatórios Google."
				/>
			</div>
		</div>
		<div className="row" style={{ marginBottom: '1px', padding: '0 0' }}>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardAdvantageBox
					icon={(<FaRegCheckCircle />)}
					altIcon=""
					titleIcon="Logo"
					title="Certificado"
					text="Geração do certificado SSL para todos os domínios utilizados (edited) "
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardAdvantageBox
					icon={(<FaAmazon />)}
					altIcon=""
					titleIcon="Logo"
					title="Hospedagem"
					text="Seu site hospedado na Amazon"
				/>
			</div>
			<div className="col-12 col-xl-4 col-lg-4 mt-4 mt-xl-0">
				<CardAdvantageBox
					icon={(<FaSearchPlus />)}
					altIcon=""
					titleIcon="Logo"
					title="SEO"
					text="Configurações para otimização para mecanismos de buscas"
				/>
			</div>
		</div>
	</div>
);

export default AdvantageBox;
